import React from 'react';
import cn from 'classnames';
import { Box } from 'components';

import styles from './Card.less';

type Props = {
  alignContent?: 'center' | 'left' | 'stretch';
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const Card: React.FC<Props> = ({ alignContent, children, className, ...rest }) => (
  <Box align={alignContent} direction="column" className={cn(styles.card, className)} {...rest}>
    {children}
  </Box>
);

Card.defaultProps = {
  alignContent: 'center',
};

export default Card;
